const validateAccountType = (accountType, options) => {
    return accountType && accountType in options;
};

const validateAccountNumber = (accountNumber) => {
  return accountNumber && accountNumber.length > 0 && accountNumber.length <= 17;
};

const validateRoutingNumber = (routingNumber) => {
  // Sample Test Routing Number: 021000021

  //Rounting number must contain at least 2 digits
  if (!routingNumber || routingNumber.length < 2) {
      return false;
  }

  let paddedRouting = routingNumber.toString();
  while (paddedRouting.length < 9) {
      paddedRouting = '0' + paddedRouting; //left-pad leading 0's
  }

  //gotta be 9 digits
  var match = paddedRouting.match("^\\d{9}$");
  if (!match) {
      return false;
  }

  //The first two digits of the nine digit RTN must be in the ranges 00 through 12, 21 through 32, 61 through 72, or 80.
  //https://en.wikipedia.org/wiki/Routing_transit_number
  const firstTwo = parseInt(paddedRouting.substring(0, 2));
  const firstTwoValid = (0 <= firstTwo && firstTwo <= 12)
      || (21 <= firstTwo && firstTwo <= 32)
      || (61 <= firstTwo && firstTwo <= 72)
      || firstTwo === 80;
  if (!firstTwoValid) {
      return false;
  }

  //Calculate the checksum
  //https://docs.oracle.com/cd/E18727_01/doc.121/e13483/T359831T498954.htm
  const weights = [3, 7, 1];
  let sum = 0;
  for (let i = 0; i < 8; i++) {
      sum += parseInt(paddedRouting[i]) * weights[i % 3];
  }

  return (10 - (sum % 10)) % 10 === parseInt(paddedRouting[8]);
};

export {
    validateAccountType,
    validateAccountNumber,
    validateRoutingNumber
};